import { render, staticRenderFns } from "./OverAllTransactionsWorldRemit.vue?vue&type=template&id=e0577db4&scoped=true"
import script from "./OverAllTransactionsWorldRemit.vue?vue&type=script&lang=js"
export * from "./OverAllTransactionsWorldRemit.vue?vue&type=script&lang=js"
import style0 from "./OverAllTransactionsWorldRemit.vue?vue&type=style&index=0&id=e0577db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0577db4",
  null
  
)

export default component.exports